import React from 'react';
import classNames from 'classnames';
import { useLinkLabel } from './useLinkLabel';
var Link = function (_a) {
    var id = _a.id, leftPosition = _a.leftPosition, rightPosition = _a.rightPosition, highlighted = _a.highlighted, label = _a.label;
    var _b = useLinkLabel(id, label, highlighted), linkPathRef = _b.linkPathRef, pathStrokeDashArray = _b.pathStrokeDashArray, labelElement = _b.labelElement;
    if (!leftPosition || !rightPosition) {
        return null;
    }
    var horizontalMid = (leftPosition.x + rightPosition.x) / 2;
    var leftCurveAnchor = { x: horizontalMid, y: leftPosition.y };
    var rightCurveAnchor = { x: horizontalMid, y: rightPosition.y };
    return (React.createElement("g", { className: 'link' },
        React.createElement("path", { ref: linkPathRef, id: id, className: classNames('link__path', { 'link__path--highlighted': highlighted }), d: "M" + leftPosition.x + "," + leftPosition.y + " \n        C" + leftCurveAnchor.x + "," + leftCurveAnchor.y + "\n        " + rightCurveAnchor.x + "," + rightCurveAnchor.y + "\n        " + rightPosition.x + "," + rightPosition.y, strokeDasharray: pathStrokeDashArray }),
        labelElement));
};
export default Link;
//# sourceMappingURL=Link.js.map